import { render, staticRenderFns } from "./AlbumUploadDock.vue?vue&type=template&id=f5542e68&"
import script from "./AlbumUploadDock.vue?vue&type=script&lang=ts&"
export * from "./AlbumUploadDock.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumUploadDock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports